import { css } from 'emotion';

import { colors } from '../../styles';

export const paginationWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: auto;
`;

export const paperStyle = css`
  && {
    box-shadow: 2px 2px 10px 0 ${colors.shadows.default};
    border: 1px solid ${colors.gray.light};
  }
`;

export const pagination = css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div:first-of-type {
    margin-left: 30px;
  }
`;
